import {CurrentPresentation} from "@api/models/interfaces/web-conference/CurrentPresentation";

export const isCurrentPresentationChanged = (newPresentation: CurrentPresentation | null, oldPresentation: CurrentPresentation | null) => {
    return newPresentation != oldPresentation ||
           newPresentation?.type != oldPresentation?.type ||
           newPresentation?.data?.slidesId != oldPresentation?.data?.slidesId ||
           newPresentation?.data?.currentSlideFileId != oldPresentation?.data?.currentSlideFileId;
}
